import React, { useState, useEffect } from 'react'
import '../../pages/SurveyStart.scss';
import { useDispatch, useSelector } from 'react-redux';
import { submitPreliminarySurveyAnswerAction, getPreliminarySurveyResultsAction } from '../../redux/attemptSurvey/attemptSurvey.actions';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const SurveyPrimaryQuestion = ({
  preliminaryQuestionId,
  comment,
  setComment,
  survey,
  isPreliminary,
  setSelectedOption,
  setSelectedOptions,
  selectedOptions,
  handleCheckboxChange,
  questionList,
  selectedOption,
  questionIndex,
  question,
  mandatory,
  options,
  points,
  maxTime,
  onChange,
  onNext
}) => {
  const dispatch = useDispatch();
  const [timeLeft, setTimeLeft] = useState(maxTime);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [showWelcomeModal, setShowWelcomeModal] = useState(true);
  const [timerActive, setTimerActive] = useState(false);
  const { isLoading, error } = useSelector((state) => state?.attemptSurveyInfo);

  const language = localStorage.getItem('language') || 'Italian';
  console.log("Question", question);
  console.log("Options", options);

  const texts = {
    Italian: {
      selectOptionError: "Seleziona un'opzione per questa domanda preliminare",
      timeExpiredTitle: "Tempo Scaduto!",
      timeExpiredBody: "La tua risposta non è stata salvata a causa della scadenza del tempo.",
      welcomeTitle: "Benvenuto alla Domanda Preliminare",
      welcomeBody: `Questa è una domanda a tempo limitato. Hai ${maxTime} secondi per rispondere. Per favore, cerca di completarla il più velocemente possibile. Nota: Devi rispondere correttamente per procedere con il sondaggio.`,
      readyButton: "Sono Pronto",
      nextButtonLoading: "Invio in corso...",
      nextButton: "Salva e Avanti",
      preliminaryQuestion: "Domanda Preliminare"
    },
    English: {
      selectOptionError: "Please select an option for this preliminary question",
      timeExpiredTitle: "Time Expired!",
      timeExpiredBody: "Your response was not saved due to time expiration.",
      welcomeTitle: "Welcome to the Preliminary Question",
      welcomeBody: `This is a timed question. You have ${maxTime} seconds to answer. Please try to complete it as quickly as possible. Note: You must answer correctly to proceed with the survey.`,
      readyButton: "I'm Ready",
      nextButtonLoading: "Submitting...",
      nextButton: "Save and Next",
      preliminaryQuestion: "Preliminary Question"
    }
  };

  useEffect(() => {
    if (!timeLeft && timerActive) {
      setShowModal(true);
      return;
    }

    let timer;
    if (timerActive) {
      timer = setInterval(() => {
        setTimeLeft(prev => prev - 1);
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [timeLeft, onNext, timerActive]);

  useEffect(() => {
    setTimeLeft(maxTime);
    setShowWelcomeModal(true);
    setTimerActive(false);
  }, [questionIndex, maxTime]);

  const handleOptionSelect = (option) => {
    const id = (option && typeof option === 'object' && option._id) ? option._id : option;
    setSelectedAnswer(id);
    setSelectedOption(id);
  };

  const handleNext = () => {
    if (!selectedAnswer && mandatory) {
      toast.error(language === 'Italian' ? texts[language].selectOptionError : texts[language].selectOptionError);
      return;
    }

    dispatch(submitPreliminarySurveyAnswerAction(
      survey,
      preliminaryQuestionId,
      selectedAnswer
    )).then(() => {
      onNext();
    });
  };

  const handleModalClose = () => {
    setShowModal(false);
    onNext();
  };

  const handleWelcomeModalClose = () => {
    setShowWelcomeModal(false);
    setTimerActive(true);
  };

  return (
    <div>
      <Modal show={showModal} onHide={handleModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{language === 'Italian' ? texts[language].timeExpiredTitle : texts[language].timeExpiredTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{language === 'Italian' ? texts[language].timeExpiredBody : texts[language].timeExpiredBody}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleModalClose}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showWelcomeModal} onHide={handleWelcomeModalClose} centered>
        <Modal.Header>
          <Modal.Title>{language === 'Italian' ? texts[language].welcomeTitle : texts[language].welcomeTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{language === 'Italian' ? texts[language].welcomeBody : texts[language].welcomeBody}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleWelcomeModalClose}>
            {language === 'Italian' ? texts[language].readyButton : texts[language].readyButton}
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="title">
        <button>
          {language === 'Italian' ? texts[language].preliminaryQuestion : texts[language].preliminaryQuestion}
        </button>
      </div>
      <div className="question_card">
        <div className="question_count">
          <div className="counts"><span>{questionIndex + 1}</span>/{questionList.length}</div>
          <div className="timer">
            <div className="spinner">
            </div>
            <div className="seconds">{timeLeft}s</div>
          </div>
        </div>
        <div className="question">
          {questionIndex + 1}. {question}
        </div>
        <div className="option_wrapper">
          {options?.map((option, index) => (
            <label key={index} className="option" htmlFor={`${questionIndex}-${index}`}>
              <input
                type="radio"
                name={`question-${questionIndex}`}
                id={`${questionIndex}-${index}`}
                checked={String(selectedAnswer || '') === String((option && typeof option === 'object' ? option._id : option) || '')}
                onChange={() => handleOptionSelect(option)}
              />
              <div className="text">
                {option?.option || option}
              </div>
              <div className="right">
                <div className="tick"></div>
              </div>
            </label>
          ))}
        </div>
        <div className="action center" style={{ cursor: 'pointer' }}>
          <button
            className="next_button"
            onClick={handleNext}
          >
            {isLoading ? (language === 'Italian' ? texts[language].nextButtonLoading : texts[language].nextButtonLoading) : (language === 'Italian' ? texts[language].nextButton : texts[language].nextButton)}
          </button>
        </div>
      </div>
    </div>
  )
}

export default SurveyPrimaryQuestion
